module.exports = __webpack_public_path__ + "static/media/conoscere per integrarsi.a7447d41.svg";